'use strict';
module.exports = require('./lib/index');



/** WEBPACK FOOTER **
 ** ./~/shortid/index.js
 **/